import { useState, useEffect } from 'react';
import './PhoneInput.css';

function PhoneInput({ value, onChange, error, disabled }) {
  const [displayValue, setDisplayValue] = useState('');

  // Format phone number for display (05X-XXX-XXXX)
  const formatPhoneDisplay = (phone) => {
    // Remove all non-digits
    const cleaned = phone.replace(/\D/g, '');
    // Limit to 10 digits
    const limited = cleaned.slice(0, 10);
    
    if (limited.length <= 3) {
      return limited;
    } else if (limited.length <= 6) {
      return `${limited.slice(0, 3)}-${limited.slice(3)}`;
    } else {
      return `${limited.slice(0, 3)}-${limited.slice(3, 6)}-${limited.slice(6)}`;
    }
  };

  // Convert to international format for Firebase (+972)
  // Input: 0501234567 → Output: +972501234567
  const toInternationalFormat = (phone) => {
    // Remove all non-digits
    const cleaned = phone.replace(/\D/g, '');
    
    // Must be 10 digits starting with 0
    if (cleaned.length === 10 && cleaned.startsWith('0')) {
      // Remove leading 0 and add +972
      return `+972${cleaned.slice(1)}`;
    }
    
    return null; // Invalid
  };

  useEffect(() => {
    if (value) {
      // If value is in international format, convert back to local for display
      let localNumber = value;
      if (value.startsWith('+972')) {
        localNumber = '0' + value.slice(4);
      }
      setDisplayValue(formatPhoneDisplay(localNumber));
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const handleChange = (e) => {
    const input = e.target.value;
    const formatted = formatPhoneDisplay(input);
    setDisplayValue(formatted);
    
    // Get clean digits
    const cleaned = input.replace(/\D/g, '');
    
    // If we have exactly 10 digits starting with 0, convert to international
    if (cleaned.length === 10 && cleaned.startsWith('0')) {
      const international = toInternationalFormat(cleaned);
      onChange(international);
    } else {
      // Pass the local format (for validation purposes)
      onChange(cleaned);
    }
  };

  // Check if valid Israeli mobile (10 digits starting with 05)
  const isValidIsraeliMobile = () => {
    const cleaned = displayValue.replace(/\D/g, '');
    return cleaned.length === 10 && cleaned.startsWith('05');
  };

  return (
    <div className={`phone-input-wrapper ${error ? 'has-error' : ''}`}>
      <div className="phone-input-container">
        <span className="phone-prefix">+972</span>
        <input
          type="tel"
          value={displayValue}
          onChange={handleChange}
          placeholder="050-123-4567"
          className={`phone-input ${isValidIsraeliMobile() ? 'valid' : ''}`}
          disabled={disabled}
          dir="ltr"
        />
        {isValidIsraeliMobile() && (
          <span className="phone-valid-icon" />
        )}
      </div>
      {error && <span className="phone-error">{error}</span>}
      <span className="phone-hint">מספר טלפון ישראלי (מתחיל ב-05)</span>
    </div>
  );
}

export default PhoneInput;
